/**
 * Utility functions for string manipulation and formatting
 */

/**
 * Decodes common HTML entities in strings
 * Useful for handling i18next translations that may contain encoded characters
 *
 * @param str - The string containing HTML entities
 * @returns The decoded string with HTML entities replaced by their actual characters
 *
 * @example
 * decodeHtmlEntities("12&#x2F;12&#x2F;25") // returns "12/12/25"
 * decodeHtmlEntities("Ben &amp; Jerry") // returns "Ben & Jerry"
 */
export const decodeHtmlEntities = (str: string): string => {
  return str
    .replace(/&#x2F;/g, '/') // Forward slash
    .replace(/&amp;/g, '&') // Ampersand
    .replace(/&lt;/g, '<') // Less than
    .replace(/&gt;/g, '>') // Greater than
    .replace(/&quot;/g, '"') // Double quote
    .replace(/&#x27;/g, "'") // Single quote
    .replace(/&#x60;/g, '`'); // Backtick
};

/**
 * Formats a date string for display, ensuring proper character encoding
 *
 * @param dateStr - The date string to format
 * @returns The formatted date string with proper characters
 */
export const formatDateString = (dateStr: string): string => {
  return decodeHtmlEntities(dateStr);
};
